// MATERIAL UI
import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const PaymentStyles = makeStyles((theme: Theme) =>
  createStyles({
    loadingContainer: {
      [theme.breakpoints.down("md")]: {
        padding: "0 16px",
      },
    },
    paymentContainer: {
      paddingBottom: "60px",
      [theme.breakpoints.down("md")]: {
        padding: "0 16px 12px 16px",
      },
    },
    title: {
      fontSize: 16,
      fontWeight: 600,
      textAlign: "center",
    },
    text: {
      fontSize: 14,
      textAlign: "center",
    },
    primaryButton: {
      backgroundColor: theme.palette.secondary.main,
      width: "auto",
      fontSize: "16px",
      fontWeight: 600,
      padding: "12px",
      borderRadis: "4px",
      height: "36px",
      textTransform: "capitalize",
      color: "#fff",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#FEDBDB",
      },
      [theme.breakpoints.down("md")]: {
        width: "165px",
      },
      [theme.breakpoints.down("sm")]: {
        width: "136px",
      },
    },
    secondaryButton: {
      backgroundColor: "#F9F9F9",
      width: "auto",
      fontSize: "16px",
      fontWeight: 400,
      padding: "12px",
      borderRadis: "4px",
      height: "36px",
      textTransform: "capitalize",
      color: "#000000",
      cursor: "pointer",
      "&:hover": {
        fontWeight: "600",
      },
      [theme.breakpoints.down("md")]: {
        width: "165px",
      },
      [theme.breakpoints.down("sm")]: {
        width: "136px",
      },
    },
    bankDetailsContainer: {
      [theme.breakpoints.down("md")]: {
        padding: "0 16px",
      },
    },
    addDetailsButton: {
      borderRadius: "25px",
      textTransform: "none",
      minWidth: "75px",
      maxHeight: "25px",
      textWrap: "nowrap",
      border: "1px solid",
    },
    eyeIconLink: {
      cursor: "pointer",
      userSelect: "none",
    },
    bankManagementPrimaryHeader: {
      fontSize: 22,
      fontWeight: 600,
    },
    bankManagementSubHeader: {
      fontWeight: 600,
      fontSize: 16,
    },
    summaryHeader: {
      fontSize: 14,
      color: "#545454",
      padding: "0 0 12px 0",
    },
    disclaimerContainer: {
      backgroundColor: "#F9F9F9",
      borderRadius: "8px",
      padding: "14px",
    },
    disclaimerHeader: {
      fontWeight: 600,
      textDecoration: "underline",
    },
    accountNumberContainer: {
      display: "inline-block",
      width: "4ch",
      textAlign: "center",
    },
  }),
);
